import { GetKaroakeListDto } from '../../../dto/getkaroakelist/getkaroakelistdto';
import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface GetKaroakeListResponse extends APIResponse
{
    getKaroakeListDto(): GetKaroakeListDto;
}

export class GetKaroakeListResponseDtoImpl extends APIResponseDtoImpl implements GetKaroakeListResponse
{
    private getKaroakeListResponseDto : GetKaroakeListDto;

    getKaroakeListDto(): GetKaroakeListDto
    {
        return this.getKaroakeListResponseDto;
    }
    setKaroakeListDto(getKaroakeListResponseDto: GetKaroakeListDto)
    {
        this.getKaroakeListResponseDto = getKaroakeListResponseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/karoake/getkaroakelist/getkaroakelistresponse.tsx